import { unsafeGameId, unsafeResourceKind, unsafeZoneId } from '@wonders/platform-core';
import { Schema as S } from 'effect';
const CardSchema = S.Struct({
    id: S.String,
    name: S.String,
    cost: S.Number,
    power: S.Number,
});
const UnitSchema = S.Struct({
    cardId: S.String,
    power: S.Number,
});
const LaneStateSchema = S.Struct({
    units: S.Unknown,
    controller: S.Union(S.String, S.Null),
});
const PlayerStateSchema = S.Struct({
    mana: S.Number,
    hand: S.Array(S.String),
    deckSize: S.Number,
});
const StateSchema = S.Struct({
    round: S.Number,
    players: S.Unknown,
    lanes: S.Tuple(LaneStateSchema, LaneStateSchema, LaneStateSchema),
    activePlayer: S.String,
    lastPassPlayer: S.Union(S.String, S.Null),
});
const MoveSchema = S.Union(S.Struct({
    kind: S.Literal('PlayUnit'),
    cardId: S.String,
    lane: S.Union(S.Literal(0), S.Literal(1), S.Literal(2)),
}), S.Struct({
    kind: S.Literal('Pass'),
}));
const EventSchema = S.Union(S.Struct({
    seq: S.Number,
    kind: S.Literal('UnitPlayed'),
    payload: S.Struct({
        cardId: S.String,
        lane: S.Union(S.Literal(0), S.Literal(1), S.Literal(2)),
    }),
    at: S.Number,
    actor: S.Union(S.String, S.Null),
}), S.Struct({
    seq: S.Number,
    kind: S.Literal('PlayerPassed'),
    payload: S.Struct({}),
    at: S.Number,
    actor: S.Union(S.String, S.Null),
}), S.Struct({
    seq: S.Number,
    kind: S.Literal('RoundEnded'),
    payload: S.Struct({
        laneControllers: S.Tuple(S.Union(S.String, S.Null), S.Union(S.String, S.Null), S.Union(S.String, S.Null)),
    }),
    at: S.Number,
    actor: S.Union(S.String, S.Null),
}));
export const demoLaneManifest = {
    id: unsafeGameId('demo-lane'),
    version: '0.1.0',
    displayName: 'Demo Lane',
    players: { mode: 'fixed', count: 2 },
    zones: [
        {
            id: unsafeZoneId('deck'),
            visibility: 'private',
            ordered: false,
            shuffleOnFill: true,
        },
        {
            id: unsafeZoneId('hand'),
            visibility: 'private',
            ordered: false,
            shuffleOnFill: false,
        },
        {
            id: unsafeZoneId('board'),
            visibility: 'public',
            ordered: false,
            shuffleOnFill: false,
        },
    ],
    phases: [
        { id: 'round-begin', actor: 'none', description: 'Start of round' },
        { id: 'main', actor: 'active', description: 'Main phase' },
        { id: 'round-end', actor: 'none', description: 'End of round' },
    ],
    resources: [
        {
            kind: unsafeResourceKind('mana'),
            cap: 10,
            resetEachTurn: false,
        },
    ],
    cardSchema: CardSchema,
    moveSchema: MoveSchema,
    stateSchema: StateSchema,
    eventSchema: EventSchema,
};
//# sourceMappingURL=manifest.js.map